import React from "react";
import { Box } from "@curves/ui-base";
import clsx from "clsx";

const TimelineRecordItem = ({className, metainfo = [], children}) => {
	return (
		<Box className={clsx("timeline-record-item", className)}>
			<Box className="timeline-record-item__meta">
				{metainfo.map((item, idx) => (
					<Box key={idx} className="timeline-record-item__meta-row">
						<span className="label">{item.label}</span>
						<span className="text">{item.text}</span>
					</Box>
				))}
			</Box>
			<Box className="timeline-record-item__card">
				{children}
			</Box>
		</Box>
	);
};

export default TimelineRecordItem;